import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createRegisterAdapter } from 'src/app/common-components/register/models/register-state.adapter';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import { multiFieldSort } from '../register-reducer.factory';
import {
   accountCallHistoryFeatureKey,
   accountCallHistoryRegisterSelector,
   AccountCallHistoryState,
} from './account-call-history.reducer';

const adapter = createRegisterAdapter<ActiveCallsRegisterListItem, any, any>({
   selectId: (item) => item.callDetailId ?? 0,
});

export const selectFilters = createSelector(accountCallHistoryRegisterSelector, (state) => {
   return state.filters;
});

export const selectAccountCallHistoryState =
   createFeatureSelector<AccountCallHistoryState>(accountCallHistoryFeatureKey);
export const selectors = adapter.getSelectors(selectAccountCallHistoryState);

export const selectOrderingOptions = createSelector(
   selectAccountCallHistoryState,
   (state) => state.orderingOptions ?? []
);

export const selectSortedActiveCalls = createSelector(
   selectors.selectAll,
   selectOrderingOptions,
   (calls, orderingOptions) => multiFieldSort(orderingOptions, calls)
);
